// extracted by mini-css-extract-plugin
export default {"customPagination":"customPagination_customPagination__CtLGb"};